import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const selectCompensationPlans = createSelector(
  selectSubCompany,
  subCompany => subCompany?.compensationPlans || [],
);
